// extracted by mini-css-extract-plugin
export default {"radiusBox":"Brand_radiusBox__+rpLl","radiusBoxGreen":"Brand_radiusBoxGreen__tWlBk","box":"Brand_box__zeb-8","boxWhite":"Brand_boxWhite__XPyRw","plus":"Brand_plus__apKGz"};